import React, { useEffect, useState } from "react";
import "./static.css";
import { Helmet } from "react-helmet";

const DummyPage: React.FC = () => {
  useEffect(() => {
    document.title = "About";
  }, []);
  return (
    <div className="dummy-container-static">
      <Helmet key="About">
        <title>About</title>
        <meta
          name="description"
          content="I Emailed 3,805 Administrators to Find Out Why a Year at Brown Costs
        $93,064."
        />
      </Helmet>
      <h1 className="dummy-heading1-static">
        I Emailed 3,805 Administrators to Find Out Why a Year at Brown Costs
        $93,064
      </h1>
      <p className="dummy-paragraph-static">By Alex Shieh</p>
      <p className="dummy-paragraph-static">
        Receiving an Ivy League education is said to unlock upward mobility, but
        with a five percent tuition hike set to take effect at Brown University
        this July, the American Dream will soon set Brown students back a
        whopping $93,064 per year — 143% of what the average American can expect
        to earn in the same timeframe. According to U.S. News & World Report,
        Brown already holds the dubious distinction of second-most expensive
        university in America, with tuition rates just $335 shy of the
        first-place University of Southern California.
      </p>
      <p className="dummy-paragraph-static">
        Assuming tuition and fees continue to increase by around four percent
        each year — as they have historically — the 2027–2028 school year at
        Brown will be the first to come with a six-figure price tag. Yet even
        while charging each student the price of a luxury car, this fiscal year,
        Brown is on track to operate at a $46 million budget deficit — dipping
        into the endowment to stay afloat. That deficit could grow even higher
        if the Trump Administration cuts Brown’s federal funding, as it has
        threatened to do so over Brown’s continued use of DEI programs that
        potentially violate the Civil Rights Act.
      </p>
      <h2 className="dummy-heading2-static">
        DEI, Redundancy, and Bullshit Jobs
      </h2>
      <p className="dummy-paragraph-static">
        Brown’s skyrocketing spending and legally questionable DEI programs
        raise serious concerns about whether tuition dollars are funding
        mission-critical functions — or just bloating the bureaucracy. Numerous
        academic studies have already pinpointed one major culprit to the rising
        costs of education nationwide — the ballooning number of university
        employees working behind-the-scenes desk jobs sitting in meetings and
        churning out memos of questionable value. Among them are dozens of DEI
        administrators who not only eat up tuition dollars, but threaten Brown’s
        federal funding.
      </p>
      <p className="dummy-paragraph-static">
        These employees in question aren’t teaching staff — professors or
        teaching assistants — nor workers filling critical operational roles
        like food service workers, janitors, or security guards. Rather they are
        a small army of mid-level administrators working out of sight, and in
        some cases completely remotely from locations thousands of miles away
        like Florida or California.
      </p>
      <p className="dummy-paragraph-static">
        Despite budget shortfalls that leave dorms flooding when it rains, Brown
        currently boasts 3,805 non-instructional full-time staff members on
        payroll — a staggering number considering Brown currently has 7,229
        undergraduate students. This makes for roughly one administrator for
        every two undergrads, meaning that every student personally foots the
        bill for half of an administrator’s salary. Brown’s non-instructional
        staff count also dwarfs the 1,691 members of the faculty, with Brown
        employing more than two administrators for every faculty member on
        payroll. Anthropologist David Graeber has described “bullshit jobs” as
        roles that feel meaningless even to those performing them — tasks that
        exist to justify bureaucracy rather than create real value. A large
        number of Brown’s non-instructional employees fit Graeber’s definition.
      </p>
      <h2 className="dummy-heading2-static">The Brown Spectator is Back</h2>
      <p className="dummy-paragraph-static">
        After an 11-year hiatus, The Brown Spectator, Brown’s leading journal of
        free thought, has obtained Brown University’s internal org chart and
        launched Bloat@Brown, an interactive website to expose the bureaucracy
        to which all 3,805 administrators belong, mapping which employees report
        to whom. Bloat@Brown also features an AI algorithm, utilizing retrieval
        augmented generation to scrape and synthesize tens of thousands of job
        postings, LinkedIn pages, and other online sources to analyze each
        administrator’s impact on the university. Administrators were analyzed
        in three domains, legality, redundancy, and bullshit jobs, and those who
        raised the algorithm’s suspicion have been flagged for manual review.
      </p>
      <p className="dummy-paragraph-static">
        The Spectator’s AI-powered employee database is part of a larger
        investigation into overstaffing at Brown. All employees in the
        Bloat@Brown database who are neither faculty members nor students, have
        been contacted for comment via email, and were asked to explain their
        roles, what tasks they performed in the past week, and how Brown
        students would be impacted if their position was eliminated. Employees
        have one week to respond, and their responses will be added to the
        public database when they are received. The results will be published
        publicly — so students, faculty, alumni, and American taxpayers can
        finally meet the bureaucracy their tuition and tax dollars fund.
      </p>
      <h2 className="dummy-subheading-static">About the Author</h2>
      <p className="dummy-paragraph-static">
        Alex Shieh is a sophomore at Brown University, a contributing Opinion
        writer for The Boston Globe, frequent Fox News guest, and the founder of
        a nationally-cited political data firm.
      </p>
      <h2 className="dummy-heading2-static">See More</h2>
      <p className="dummy-paragraph-static">
        <a
          className="dummy-link-static"
          href="/contact"
          rel="noopener noreferrer"
        >
          Contact the team
        </a>
      </p>
      <p className="dummy-paragraph-static">
        <a className="dummy-link-static" href="/" rel="noopener noreferrer">
          Explore Brown's org chart
        </a>
      </p>
      <p className="dummy-paragraph-static">
        <a
          className="dummy-link-static"
          href="https://x.com/brown_spectator"
          target="_blank"
          rel="noopener noreferrer"
        >
          Check us out on X
        </a>
      </p>
    </div>
  );
};

export default DummyPage;
